export const isAdminUser = (permissions) => {
    return permissions && permissions.includes('ADMIN');
}